// src/pages/VerifyEmail.js
import React, { useEffect, useState } from "react";
import { auth } from "../services/firebase";
import { applyActionCode } from "firebase/auth";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./Login.css";

function VerifyEmail() {
  const [status, setStatus] = useState("verifying");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const oobCode = searchParams.get("oobCode");
    if (oobCode) {
      applyActionCode(auth, oobCode)
        .then(() => {
          setStatus("success");
          setTimeout(() => navigate("/login"), 6000);
        })
        .catch((err) => {
          console.error('Verification error:', err);
          setStatus('error');
        });
    } else {
      setStatus("invalid");
    }
  }, [searchParams, navigate]);

  return (
    <div className="login-root">
      <div className="login-left">
        <div className="login-card">
          <div className="login-logo-row">
            <div className="login-logo">BAI</div>
            <span className="login-appname">BodhAI</span>
          </div>
          <h2 className="login-welcome">Verify Email</h2>
          <div style={{ margin: "2.5rem 0 1.5rem 0", minHeight: 60 }}>
            {status === "verifying" && <p style={{ color: "#0ff1ce", fontWeight: 500 }}>🔄 Verifying email...</p>}
            {status === "success" && <p style={{ color: "#22c55e", fontWeight: 500 }}>✅ Email verified! Redirecting to login...</p>}
            {status === "error" && <p style={{ color: "#ef4444", fontWeight: 500 }}>❌ Invalid or expired verification link.</p>}
            {status === "invalid" && <p style={{ color: "#f59e42", fontWeight: 500 }}>⚠️ Missing verification code in URL.</p>}
          </div>
          <div className="login-bottom-row">
            <a href="/login" className="login-link">← Back to Login</a>
          </div>
        </div>
      </div>
      <div className="login-right">
        <div className="login-showcase-card">
          <h2>Secure Your Account</h2>
          <p>Email verification helps keep your BodhAI account safe and secure.</p>
          <div className="login-stats-row">
            <div className="login-stat">
              <div className="login-stat-value">100%</div>
              <div className="login-stat-label">Verified</div>
            </div>
            <div className="login-stat">
              <div className="login-stat-value">24/7</div>
              <div className="login-stat-label">Support</div>
            </div>
            <div className="login-stat">
              <div className="login-stat-value">1M+</div>
              <div className="login-stat-label">Accounts</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
